const SURVEYS_STORAGE_KEY = "gamescom-surveys-v2";

export type SurveyArea = "neozone" | "openzone" | "final";

export type NeozoneSurvey = {
  area: "neozone";
  visitedBooth: string | null;
  whyDitintEvaluate: string | null;
  gamesSelection: number | null;
  lines: number | null;
  gift: number | null;
  service: number | null;
  comment: string;
};

export type OpenzoneSurvey = {
  area: "openzone";
  graphics: number | null;
  gameplay: number | null;
  fun: number | null;
  challenge: number | null;
  ambience: number | null;
  comment: string;
};

export type FinalSurvey = {
  area: "final";
  overallExperience: number | null;
  motivation: string | null;
  favoriteWorld: string | null;
  comment: string;
};

export type SurveysStorage = {
  neozone: NeozoneSurvey;
  openzone: OpenzoneSurvey;
  final: FinalSurvey;
};
function getInitialSurveyStorage(): SurveysStorage {
  return {
    neozone: {
      area: "neozone",
      visitedBooth: null,
      whyDitintEvaluate: null,
      gamesSelection: null,
      lines: null,
      gift: null,
      service: null,
      comment: "",
    },
    openzone: {
      area: "openzone",
      graphics: null,
      gameplay: null,
      fun: null,
      challenge: null,
      ambience: null,
      comment: "",
    },
    final: {
      area: "final",
      overallExperience: null,
      motivation: null,
      favoriteWorld: null,
      comment: "",
    },
  };
}

export function getStoredSurveys(): SurveysStorage {
  const raw = localStorage.getItem(SURVEYS_STORAGE_KEY);

  if (!raw) {
    return getInitialSurveyStorage();
  }

  try {
    const parsed = JSON.parse(raw) as Partial<SurveysStorage>;
    const initial = getInitialSurveyStorage();

    return {
      neozone: {
        ...initial.neozone,
        ...parsed.neozone,
      },
      openzone: {
        ...initial.openzone,
        ...parsed.openzone,
      },
      final: {
        ...initial.final,
        ...parsed.final,
      },
    };
  } catch (error) {
    console.error("Erro ao ler surveys do localStorage:", error);
    return getInitialSurveyStorage();
  }
}

export function saveStoredSurveys(data: SurveysStorage): void {
  localStorage.setItem(SURVEYS_STORAGE_KEY, JSON.stringify(data));
}

export function clearStoredSurveys(): void {
  localStorage.removeItem(SURVEYS_STORAGE_KEY);
}

export function updateSurveyArea<K extends SurveyArea>(
  area: K,
  patch: Partial<SurveysStorage[K]>
): void {
  const current = getStoredSurveys();

  const updated: SurveysStorage = {
    ...current,
    [area]: {
      ...current[area],
      ...patch,
    },
  } as SurveysStorage;

  saveStoredSurveys(updated);
}